import { QueryClient } from '@tanstack/react-query'
import type { ApiError } from './client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: (count, err) => {
        const e = err as unknown as ApiError
        // Không retry 4xx (trừ 408)
        if (e?.status && e.status >= 400 && e.status < 500 && e.status !== 408) return false
        return count < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
